import React from 'react';
import Button from "react-bootstrap/Button";
import FileUpload from "../../common/FileUpload";
import BaseProps from "../../types/BaseProps";

type LicenseSelectorProps = BaseProps & {
  onSelected: (file: File) => void
};

type LicenseSelectorState = {
  fileUploadToggled: boolean
};

/**
 * License file selector component. Handles only files with the .license extension.
 */
class LicenseSelector extends React.Component<LicenseSelectorProps, LicenseSelectorState> {

  constructor(props: LicenseSelectorProps) {
    super(props);
    this.state = {
      fileUploadToggled: false
    };
    this.openFileUpload = this.openFileUpload.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  openFileUpload() {
    this.setState({
      fileUploadToggled: !this.state.fileUploadToggled
    });
  }

  handleSelection(files: Array<File>) {
    if (files.length > 0) {
      this.props.onSelected(files[0]);
    }
  }

  render() {
    return (
      <span className={this.props.className}>
      <Button variant="secondary" size="sm" onClick={this.openFileUpload}>
        Set
      </Button>
      <FileUpload changeHandler={this.handleSelection}
                  toggle={this.state.fileUploadToggled}
                  accept=".license"
                  multiple={false}/>
    </span>
    );
  }
}

export default LicenseSelector;
